import type { AnyFunction } from '../types';

type DebouncedFunction<T extends AnyFunction> = T & {
    cancel: () => void;
    isWaiting: () => boolean;
};

export const debounce = <T extends AnyFunction>(func: T, delay: number): DebouncedFunction<T> => {
    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    const debounced = function (this: ThisParameterType<T>, ...args: Parameters<T>) {
        if (delay < 1) {
            func.apply(this, args);
            return;
        }
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(this, args);
            timeoutId = undefined;
        }, delay);
    } as DebouncedFunction<T>;

    debounced.cancel = () => {
        clearTimeout(timeoutId);
        timeoutId = undefined;
    };

    debounced.isWaiting = () => timeoutId !== undefined;

    return debounced;
};
